import { BaseAction } from "./BaseAction";
export class JavaScriptCallAction extends BaseAction {
    execute() {
        try {
            new Function(this.action.html)();
        }
        catch (e) {
            console.error("JavaScriptCall failed:", e);
        }
        return true;
    }
}
